const promptBarConfig = {
    placeholder: "Type your prompt here...",
    autoFocus: true,
    maxLength: 500,
    showCharCount: true,
    leftActions: [
        // {
        //     id: "advanced",
        //     icon: "Lightbulb",
        //     tooltip: "Promp Editor",
        //     onClick: () => console.log("Attach file clicked"),
        // },
    ],
    rightAction: {
        id: "submit",
        icon: "Send",
        tooltip: "Send message",
        onClick: () => console.log("Submit clicked"),
    },
    inputProps: {
        multiline: true,
        minRows: 1,
        maxRows: 5,
        variant: "outlined",
        fullWidth: true,
    },
};

export default promptBarConfig;